'use client'

import LinkButton from '../link-button/link-button'
import IntroImage from './intro-image'
import IntroHeading from './intro-heading'
import styles from './styles/intro.module.css'

const IntroSection = ({ CMSData }) => {
  const { introHeading, introButton, introImages } = CMSData

  return (
    <div>
      <div className={styles.headerImgDiv}>
        {introImages?.data?.map(item => (
          <IntroImage key={item?.id} alt={item?.attributes?.name} img={item?.attributes?.url} />
        ))}
      </div>
      <IntroHeading introHeading={introHeading} />
      <LinkButton
        eventName="first btn clicked see open positions"
        btnText={introButton?.buttonText}
        btnStyle={introButton?.buttonStyle}
        btnLink={`/careers/${introButton?.buttonLink}`}
      />
    </div>
  )
}

export default IntroSection
